import { render, staticRenderFns } from "./dm-detail.vue?vue&type=template&id=81d2537e&scoped=true"
import script from "./dm-detail.vue?vue&type=script&lang=js"
export * from "./dm-detail.vue?vue&type=script&lang=js"
import style0 from "./dm-detail.vue?vue&type=style&index=0&id=81d2537e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d2537e",
  null
  
)

export default component.exports